import { Component } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unknown error" };
  }
  componentDidCatch(error, info) {
    axios.post(`${API}/client-errors`, {
      message: String(error?.message || error),
      stack: String(error?.stack || ""),
      component_stack: String(info?.componentStack || ""),
      url: typeof window !== "undefined" ? window.location.href : "",
    }).catch(() => {});
  }
  reset = () => { this.setState({ hasError: false, message: "" }); window.location.assign("/"); };
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center px-6">
        <div className="max-w-md text-center border border-slate-200 p-8 bg-white">
          <div className="mono text-[10px] tracking-[0.22em] uppercase text-topo">Unexpected error</div>
          <h1 className="display mt-3 text-3xl font-extrabold tracking-tighter text-slate-900">Something went wrong.</h1>
          <p className="mt-3 text-sm text-slate-600">Our team has been notified. Try heading back to the homepage.</p>
          <button onClick={this.reset} data-testid="error-back-home" className="mt-5 inline-flex rounded-sm bg-orange-survey hover:bg-orange-survey-dark text-white text-sm font-semibold px-5 py-3">Back to home</button>
        </div>
      </div>
    );
  }
}
